import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { ISimTypeModel } from '@apps-common/types/management/sim-type'

export const createSimType = async (model: ISimTypeModel): Promise<ISimTypeModel> =>
  axios.post(`/management/simtype/addsimtype`, model).then((res) => res?.data?.data)

type Props = {
  model: ISimTypeModel
}

export const useManagementCreateSimType = (notify?: boolean, onSuccess?: (data: ISimTypeModel) => void) =>
  useMutation({
    mutationKey: ['createSimType'],
    mutationFn: ({ model }: Props) => createSimType(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created sim type.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to create sim type, please try again.')
      }
    },
    throwOnError: false
  })
